import { MeetingResponseType } from 'mini-calendar-event-services';
import { RsvpAction } from '../schema/RsvpAction';

export const getResponseTypeFromAction = (action: RsvpAction, isOrganiser?: boolean) => {
    let responseType: MeetingResponseType = isOrganiser ? 'Organizer' : 'Unknown';

    if (!isOrganiser) {
        switch (action) {
            case RsvpAction.YES:
                responseType = 'Accept';
                break;
            case RsvpAction.MAYBE:
                responseType = 'Tentative';
                break;
            case RsvpAction.NO:
                responseType = 'Decline';
                break;
        }
    }

    return responseType;
};
